import React, { useState } from "react";

function Input({
  id,
  label,
  name,
  type = "text",
  value,
  onChange,
  error = false,
  errorMessage = "",
  disabled = false,
  placeholder = "",
  maxCharacter,
  marginBottom = "",
  options = [],
  maxLength,
}) {
  const [exceededLimitError, setExceededLimitError] = useState(false);

  const handleKeyDown = (e) => {
    if (
      maxCharacter &&
      e.target.value.length >= maxCharacter &&
      e.key !== "Backspace"
    ) {
      e.preventDefault();
      setExceededLimitError(true);
    } else {
      setExceededLimitError(false);
    }
  };

  const handleChange = (e) => {
    let val = e.target.value;

    if (maxCharacter) {
      val = val.slice(0, maxCharacter);
    }

    if (type === "number") {
      val = val === "" ? "" : Number(val);
    }

    onChange({
      target: {
        name,
        value: val,
      },
    });
  };

  const hasError = !!error || exceededLimitError;

  let className = "form-control";
  if (hasError) className += " is-invalid";

  return (
    <div className={`form-group ${marginBottom}`}>
      {label && (
        <label className="lead mr-2" style={{ fontSize: "16px" }}>
          {label}
        </label>
      )}

      {type === "select" ? (
        <select
          id={id}
          name={name}
          value={value}
          onChange={handleChange}
          className={className}
          disabled={disabled}
        >
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      ) : (
        <input
          id={id}
          type={type}
          name={name}
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          className={className}
          disabled={disabled}
          placeholder={placeholder}
          autoComplete="off"
          maxLength={maxLength}
        />
      )}

      {exceededLimitError && (
        <div className="invalid-feedback">
          Only {maxCharacter} characters allowed
        </div>
      )}

      {error && !exceededLimitError && (
        <div className="invalid-feedback">
          {typeof error === "string" ? error : errorMessage || "Required"}
        </div>
      )}
    </div>
  );
}

export default Input;
